export const listOffers = `
   query listOffers($filter: OffersFilterInput, $limit: Int, $nextToken: String, $sort: SortInput) {
       listOffers(filter: $filter, limit: $limit, nextToken: $nextToken, sort: $sort) {
           items {
              id
              name
              created
              updated
           }
           nextToken
       }
   }
`;

export const getOffer = `
   query getOffer($id:ID!) {
       getOffer(id:$id) {
         id
         name
       }
}`;
